import { useEffect } from "react";
import debounce from "lodash/debounce";

const useDebounce = (callback, delay) => {
  const debouncedFn = debounce(callback, delay);

  useEffect(() => {
    return () => {
      debouncedFn.cancel();
    };
  }, [debouncedFn]);

  return debouncedFn;
};

export default useDebounce;
